<template lang="pug">
    .container
        .title-container
            .title-group
                p.step 
                    strong STEP 01: 
                    | Start with the event type 
                h3 What kind of event you are looking for?

        .event-categories
            event(v-for="event in allEvents" :event="event" :key="event.id")

            .loading-button(v-if="wait")
            
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Event from './Event';

    export default {
        name: 'EventCategory',
        data() {
            return {
                wait: true
            };
        },
        components: {
            Event
        },
        computed: mapGetters(['allEvents']),
        methods: mapActions(['fetchEvents', 'addToTotal']),
        created() {
            this.fetchEvents().then(() => {
                this.wait = false;
            });

            // clear the total
            this.addToTotal({"type": 'participation', 'total': 0})
            this.addToTotal({"type": 'accommodation', 'total': 0})
            this.addToTotal({"type": 'meal', 'total': 0})
            this.addToTotal({"type": 'activity', 'total': 0})
            this.addToTotal({"type": 'resource', 'total': 0})
        }
    };
</script>

<style lang="sass" scoped>
    .event-categories
        position: relative
</style>


